import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { State, workerAddressDetails } from '../../Models/Admin/worker-address';
import { Documents } from '../../Models/Material-Dispatch/MaterialDispatch';
import { WorkerAddressService } from '../../Services/admin-rights/worker-address.service';
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component';
import * as XLSX from "xlsx"
import { Router } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-worker-address',
  templateUrl: './worker-address.component.html',
  styleUrls: ['./worker-address.component.css'],
  providers: [DatePipe]
})
export class WorkerAddressComponent implements OnInit {

  loader: string = 'none';
  userID: string;
  roleID: string;
  workerAddressDetail:workerAddressDetails[];
  workaddress:workerAddressDetails;
  workinitaddress:workerAddressDetails;
  state:State[];
  IsFileCorrect:boolean=false;
  files: File[] = [];
  document: Documents = new Documents();
  arrayBuffer: any;
  filelist: any;
  displayAddAddressPanel:string='none';
  popAddress:string;
  popCity:string
  popPinCode:number;
  accessdata:string='';// add by deepanshu 15 june 2023
  popState:string
  constructor(private workerAddressService: WorkerAddressService, private router: Router, private snackBar: MatSnackBarComponent,private datePipe:DatePipe,private toastr: ToastrService) {
    this.roleID = localStorage.getItem('mcmt_roleID');
    this.userID = localStorage.getItem('mcmt_userId');
  }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.getWorkerAddressDetails();
    this.getStateDropdown();
    this.workaddress=new workerAddressDetails;
  }
getStateDropdown()
{
  this.workerAddressService.getworkerFilter().subscribe((resdata:any)=>{ if (resdata.status == true) {this.state=resdata.data;}})
}
  getWorkerAddressDetails() {
    this.loader = 'block';
    this.workinitaddress=new workerAddressDetails;
    this.workinitaddress.loggedInUser=this.userID ;
    this.workinitaddress.action="SELECT";
    this.workerAddressService.getWorkerDetail(this.workinitaddress)
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.workerAddressDetail = resdata.data;
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
  }
  viewEditAddressPanel(detail:any)
  {
    this.displayAddAddressPanel='block';
    this.workaddress.userid=detail.userid;
    this.workaddress.username=detail.username;
    this.workaddress.designation=detail.designation;
    this.workaddress.id=detail.id;
    this.popAddress=detail.streetAddress
    this.popCity=detail.city;
    this.popPinCode=detail.pincode;
    this.popState=detail.state;
    //this.workaddress=detail; 
    this.getStateDropdown();
    if(this.popState==undefined || this.popState=="" || this.popState==null)
    {
      this.popState=this.state[0].state;
    }
    const body = document. getElementsByTagName('body')[0];
    body.classList.add('overlay-back');
  }
  closePanel()
  {
    this.displayAddAddressPanel='none';
    this.popState=this.state[0].state;
    this.popAddress="";
    this.popCity="";
    this.popPinCode=null;
    this.getWorkerAddressDetails();
    const body = document. getElementsByTagName('body')[0];
    body.classList.remove('overlay-back');
  }
  SaveworkerAddress()
  {
    if(this.popAddress!="" && this.popAddress!=null  && this.popCity!="" && this.popCity!=null  && this.popState!="" && this.popPinCode!=null)
    {
      if(this.popPinCode.toString().length==6 && this.popPinCode.toString().indexOf('.')==-1)
      {
      this.loader = 'block';
      this.workaddress.action="INSERT";
      this.workaddress.streetAddress=this.popAddress;
      this.workaddress.city=this.popCity;
      this.workaddress.pincode=this.popPinCode.toString();
      this.workaddress.state=this.popState;

            this.workerAddressService.getWorkerDetail(this.workaddress)
        .subscribe((resdata: any) => {
          if (resdata.status == true) {
            this.workerAddressDetail = resdata.data;
            this.loader = 'none';
            this.displayAddAddressPanel='none';
            this.getWorkerAddressDetails();
          }
          else {
            this.toastr.error(resdata.msg);
            this.loader = 'none';
          }
        })
      }
      else
      this.toastr.error("Invalid Pin Code");

    }
    else
    {
      this.toastr.error("Please enter the required input");
    }
  }

  DownloadWorkerAddressExcel() {
    this.loader = 'block';
  //  this.Status = Array.prototype.map.call(this.dropdownStatus,function(item){return item.item_text; }).join(",");//'10,11,12'
    this.workerAddressService.DownloadWorkerAddressExcel()
      .subscribe(
        success => {
          var date = new Date();
          var latest_date = this.datePipe.transform(date, 'dd-MMM-yy');
          var Name = localStorage.getItem('mcmt_userName').split(' ');
          var Firstname = Name[0];
          var LastName = Name[1];
          var ExcelName = Firstname + '_' + LastName + '_WorkerAddress_' + latest_date + '.xlsx';
          //let roleId=localStorage.getItem('mcmt_roleID');
          if (success.size > 0)
            saveAs(success, ExcelName);
          else
            this.toastr.error("No Records available for Excel.");
          this.loader = 'none';
        },
        err => {
          this.toastr.error("Some problem occurred while downloading file.");
          this.loader = 'none';
          console.log(err);
        }
      );
  }

  filesDroppedAdd(files: File[]) {
    this.loader = 'block';
    this.files = [];
    this.files = files;
    let fileNameParts: string[] = files[0].name.split('.');
    let fileType = files[0].name.split('.')[fileNameParts.length - 1];
    let CorrectFileName = 'WorkerAddress'
    //console.log(fileNameParts[0].includes(CorrectFileName));
    if (fileNameParts[0].includes(CorrectFileName)) {
      this.IsFileCorrect = true;
    }
    else {
      this.IsFileCorrect = false;
    }
    if (this.IsFileCorrect == false) {
      this.toastr.error('Please Select Valid File.');
      this.loader = 'none';
      return false;
    }
    if (fileType != 'xls' && fileType != 'xlsx') {
      this.toastr.error('Please Select Valid File Type.');
      this.loader = 'none';
      return false;
    }
    else {
      this.loader = 'block';
      this.document.file = <File>this.files[0];
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(<File>this.files[0]);
      fileReader.onload = (e) => {
        this.arrayBuffer = fileReader.result;
        var data = new Uint8Array(this.arrayBuffer);
        var arr = new Array();
        for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
        var bstr = arr.join("");
        var workbook = XLSX.read(bstr, { type: "binary" });
        var first_sheet_name = workbook.SheetNames[0];
        var worksheet = workbook.Sheets[first_sheet_name];
        this.filelist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
       // this.filelist.Add("LoggedinUser",this.userID);
       this.workerAddressService.UploadWorkerAddressExcel(this.filelist).subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.loader = 'none';
          this.displayAddAddressPanel='none';
          this.toastr.success('Upload Successfully');
          this.getWorkerAddressDetails();
        }
        else {
          this.toastr.error(resdata.message);
          this.loader = 'none';
        }
      })
        this.files = [];
        this.loader = 'none';
      }
    }
  
}
}
